import "@/App.css";
import "@/md-buttons.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import PlayerRoute from "./components/PlayerRoute";
import CodeLogin from "./pages/CodeLogin";
import Welcome from "./pages/Welcome";
import CommentJouer from "./pages/CommentJouer";
import CameraSetup from "./pages/CameraSetup";
import Play from "./pages/Play";
import ThankYou from "./pages/ThankYou";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import WatchVideo from "./pages/WatchVideo";
import { GameProvider } from "./context/GameContext";

function App() {
  return (
    <div className="App dark">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#0f2447",
            border: "1px solid rgba(79,195,247,0.25)",
            color: "#FFFFFF",
            fontFamily: "'Poppins', sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <GameProvider>
          <Routes>
            <Route
              path="/"
              element={
                <PlayerRoute>
                  <CodeLogin />
                </PlayerRoute>
              }
            />
            <Route
              path="/welcome"
              element={
                <PlayerRoute>
                  <Welcome />
                </PlayerRoute>
              }
            />
            <Route
              path="/comment-jouer"
              element={
                <PlayerRoute>
                  <CommentJouer />
                </PlayerRoute>
              }
            />
            <Route
              path="/camera"
              element={
                <PlayerRoute>
                  <CameraSetup />
                </PlayerRoute>
              }
            />
            <Route
              path="/play"
              element={
                <PlayerRoute>
                  <Play />
                </PlayerRoute>
              }
            />
            <Route
              path="/thank-you"
              element={
                <PlayerRoute>
                  <ThankYou />
                </PlayerRoute>
              }
            />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/watch/:sessionId" element={<WatchVideo />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </GameProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
